import React, { useEffect, useRef, useState } from 'react';

interface ImgLazyLoadProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

const ImgLazyLoad: React.FC<ImgLazyLoadProps> = ({ src, alt, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '10px' }
    );

    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return <img ref={imgRef} src={isVisible ? src : ''} alt={alt} {...props} />;
};

export default ImgLazyLoad;
